import { fill } from './fill.js'
import templateUrl from './template.pdf'

export default {
  key: 'pvrc1to6_2023_09',
  templateUrl,
  fill,
}
